import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import config from '../../config/config'
import PoiThumbnail from './PoiThumbnail'

const PoiInternalLinks = ({ poi }) => {
  const { t } = useTranslation()
  const [poiInternalLinks, setPoiInternalLinks] = useState([])

  useEffect(() => {
    const fetchPoiInternalLinks = async () => {
      try {
        const response = await axios.get(
          `${config.apiUrl}poi-internal-link?poi=${poi.id}`,
        )
        setPoiInternalLinks(response.data)
      } catch (error) {
        // console.error('An error occurred while fetching internal links:', error)
      }
    }

    fetchPoiInternalLinks()
  }, [poi.id])

  return (
    <div>
      {poiInternalLinks && poiInternalLinks.length > 0 && (
        <div className="mt-4">
          <hr />
          <h2 className="mb-4">{t('SEE_ALSO')}</h2>
          <div className="row g-4">
            {poiInternalLinks.map((poiInternalLink) => (
              <div
                className="col-md-6 col-lg-4 d-flex"
                key={poiInternalLink.linkedPoi.id}
              >
                <PoiThumbnail
                  poi={poiInternalLink.linkedPoi}
                  isCategory={true}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default PoiInternalLinks
